/**
 * Image hosts Next.js may fetch and resize (next.config.ts remotePatterns).
 * Shared with `edImage`, which only routes these through the resizer.
 */
export const IMAGE_REMOTE_HOSTS = [
	"fvcfznfsghdlrlbcfdyb.supabase.co",
	"zmlkjrukqpxhzkgugwdx.supabase.co",
	"cdn.sanity.io",
	"cdn.klaviyomail.com",
	"d3k81ch9hvuctc.cloudfront.net",
	"placehold.co",
	"i.ytimg.com",
	"image-cdn-ak.spotifycdn.com",
	"i.scdn.co",
	"is1-ssl.mzstatic.com",
	"img.youtube.com",
	"www.youtube.com",
	"image.mux.com",
	"picsum.photos",
	"api.dicebear.com",
	"core.colorsxstudios.com",
] as const;
